$(document).ready(function () {
  $(".job-desc").hide();
  $(".job-title").on("click", function (event) {
    event.preventDefault();
    $(this).parent().toggleClass('open');
    $(this).next(".job-desc").slideToggle();
  });
});
